<template>
    <div>
        <div class="header pb-2 d-flex align-items-center bg-integration">
            <div class="container align-items-center mt-9 mb-4">
                <div class="row mb-5">
                    <div class="col">
                        <h1 class="display-1 text-white mt-0 mb-5 text-white" style="font-weight: 400; text-shadow: 1px 1px #000;">
                            Интеграция
                        </h1>
                        <h1 class="text-white" style="font-weight: 400; text-shadow: 1px 1px #000;">
                            Интегрируйте Командор в собственную информационную систему, благодаря открытому API и модулю Командор CSP для Node.js
                        </h1>
                    </div>
                </div>
            </div>
            <div class="separator separator-bottom separator-skew zindex-100">
                <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1" xmlns="http://www.w3.org/2000/svg">
                    <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
                </svg>
            </div>
        </div>

        <!-- Форма заявки -->
        <div class="container mt--6 pb-5">
            <div class="row justify-content-center">
                <div class="col-lg-5 col-md-7">
                    <div class="card bg-secondary border-0 mb-0">
                        <div class="card-header bg-transparent pb-5">
                            <div class="text-muted text-center mt-2 mb-3"><small>Заполните форму и с вам свяжется наш специалист</small></div>
                            <template>
                                <form role="form">
                                    <div class="form-group">
                                        <div class="input-group input-group-alternative mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="fas fa-user"></i></span>
                                            </div>
                                            <input v-model="login" class="form-control form-control-alternative" placeholder="Ваше имя" type="text">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="input-group input-group-alternative mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="fas fa-building"></i></span>
                                            </div>
                                            <input v-model="login" class="form-control form-control-alternative" placeholder="Название компании" type="text">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="input-group input-group-alternative mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="fas fa-mobile"></i></span>
                                            </div>
                                            <input v-model="login" class="form-control form-control-alternative" placeholder="Номер телефона" type="text">
                                        </div>
                                    </div>
                                    <div class="form-group">
                                        <div class="input-group input-group-alternative mb-3">
                                            <div class="input-group-prepend">
                                                <span class="input-group-text"><i class="fas fa-envelope"></i></span>
                                            </div>
                                            <input v-model="login" class="form-control form-control-alternative" placeholder="Электронная почта" type="text">
                                        </div>
                                    </div>
                                    <div v-if="error">
                                        {{ error }}
                                    </div>
                                    <div class="text-center">
                                        <base-button type="danger" class="my-4" @click="handleLogin">Отправить запрос</base-button>
                                    </div>
                                </form>
                            </template>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-6">
                            <router-link to="#" class="text-light"><small>Правила</small></router-link>
                        </div>
                        <div class="col-6 text-right">
                            <router-link to="#" class="text-light"><small>Конфиденциальность</small></router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>
<script>
  export default {
    data () {
      return {
        // color: 'rgb(255,255,255, 1)'
        color: '#ced4da'
      }
    },
  };
</script>
<style>
    .bg-integration {
        background-image: url(/img/bg-integration.jpg);
        background-size: cover;
        background-position: center top;
        min-height: 525px;
    }
</style>
